export default __webpack_public_path__ + "static/media/yd-s1.fed1c553.png";